import { useRouteLoaderData } from 'react-router'
import { useIsClient } from 'usehooks-ts'
import { GoogleTagManager } from './google-tag-manager'
import { Rudderstack } from './rudderstack'
import { GA_TRACKING_ID } from '~/config'
import type { loader as rootLoader } from '~/root'

/**
 * Rendered by both the root App and the root ErrorBoundary so that error
 * pages (404s especially) still load GTM and report a pageview. Loader data
 * is read via useRouteLoaderData because the ErrorBoundary renders in place
 * of App; it can be undefined when the root loader itself threw, in which
 * case the tag managers are skipped.
 */
export const Analytics = () => {
  const data = useRouteLoaderData<typeof rootLoader>('root')
  const isClient = useIsClient()

  return (
    <>
      {/* The canonical GTM snippet: the inline script creates the dataLayer
          and stamps gtm.start before injecting gtm.js itself, so ordering is
          guaranteed. A separate `<script async src>` can't promise that —
          React 19 hoists it into <head> ahead of any inline bootstrap. */}
      <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GA_TRACKING_ID}');`,
        }}
      ></script>
      {data && !data.isDevelopment && isClient && (
        <>
          <Rudderstack />
          <GoogleTagManager referrer={data.referrer} tracking={data.tracking} />
        </>
      )}
    </>
  )
}
